<template lang="html">
  <div
    class="zoom-on-hover"
    @mousemove="move"
    @mouseenter="zoom"
    @mouseleave="unzoom"
  >
    <img class="normal" ref="normal" alt="" v-lazy="imgNormal" />
    <div class="cursor" ref="cursor">
      OPEN
    </div>
    <img class="zoom" ref="zoom" alt="" v-lazy="imgZoom || imgNormal" />
  </div>
</template>

<script>
export default {
  props: ["imgNormal", "imgZoom", "scale", "disabled"],
  data: function() {
    return {
      scaleFactor: 0.5,
      resizeCheckInterval: null
    };
  },
  methods: {
    pageOffset: function(el) {
      // -> {x: number, y: number}
      // get the left and top offset of a dom block element
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
        y: rect.top + scrollTop,
        x: rect.left + scrollLeft
      };
    },
    zoom: function() {
      if (this.disabled) return;
      this.$refs.zoom.style.opacity = 1;
      this.$refs.cursor.style.opacity = 1;
      this.$refs.normal.style.opacity = 0;
    },
    unzoom: function() {
      if (this.disabled) return;
      this.$refs.zoom.style.opacity = 0;
      this.$refs.cursor.style.opacity = 0;
      this.$refs.normal.style.opacity = 1;
    },
    move: function(event) {
      if (this.disabled) return;
      var offset = this.pageOffset(this.$el);
      var zoom = this.$refs.zoom;
      var cursor = this.$refs.cursor;
      var normal = this.$refs.normal;
      var relativeX = event.clientX - offset.x + window.pageXOffset;
      var relativeY = event.clientY - offset.y + window.pageYOffset;
      var normalFactorX = relativeX / normal.offsetWidth;
      var normalFactorY = relativeY / normal.offsetHeight;
      var x =
        normalFactorX *
        (zoom.offsetWidth * this.scaleFactor - normal.offsetWidth);
      var y =
        normalFactorY *
        (zoom.offsetHeight * this.scaleFactor - normal.offsetHeight);
      zoom.style.left = -x + "px";
      zoom.style.top = -y + "px";
      cursor.style.left = relativeX - cursor.offsetWidth / 2 + "px";
      cursor.style.top = relativeY - cursor.offsetHeight / 2 + "px";
    },
    initEventLoaded: function() {
      // emit the "loaded" event if all images have been loaded
      var promises = [
        this.$refs.zoom,
        this.$refs.cursor,
        this.$refs.normal
      ].map(function(image) {
        return new Promise(function(resolve, reject) {
          image.addEventListener("load", resolve);
          image.addEventListener("error", reject);
        });
      });
      var component = this;
      Promise.all(promises).then(function() {
        component.$emit("loaded");
      });
    },
    initEventResized: function() {
      var normal = this.$refs.normal;
      var previousWidth = normal.offsetWidth;
      var previousHeight = normal.offsetHeight;
      var component = this;
      this.resizeCheckInterval = setInterval(function() {
        if (
          previousWidth != normal.offsetWidth ||
          previousHeight != normal.offsetHeight
        ) {
          previousWidth = normal.offsetWidth;
          previousHeight = normal.offsetHeight;
          component.$emit("resized", {
            width: normal.width,
            height: normal.height,
            fullWidth: normal.naturalWidth,
            fullHeight: normal.naturalHeight
          });
        }
      }, 1000);
    }
  },
  mounted: function() {
    if (this.$props.scale) {
      this.scaleFactor = parseInt(this.$props.scale);
      this.$refs.zoom.style.transform = "scale(1)";
    }
    this.initEventLoaded();
    this.initEventResized();
  },
  updated: function() {
    this.initEventLoaded();
  },
  beforeDestroy: function() {
    this.resizeCheckInterval && clearInterval(this.resizeCheckInterval);
  }
};
</script>

<style lang="scss" scoped>
.zoom-on-hover {
  width: 100%;
  height: 30vw;
  margin-bottom: 0.5rem;
  @media only screen and (max-width: 768px) {
    height: auto;
  }
  cursor: none;
}
.zoom-on-hover {
  position: relative;
  overflow: hidden;
}
.zoom-on-hover .normal {
  width: 100%;
  height: 100%;
  object-fit:cover;
  z-index: 30;
  transition: opacity 0.5s;
}
.zoom-on-hover .zoom {
  position: absolute;
  opacity: 0;
  transition: opacity 0.5s;
  transform-origin: top left;
  z-index: 74;
}
.zoom-on-hover .cursor {
  position: absolute;
  opacity: 0;
  z-index: 999;
  transform-origin: top left;
  cursor: none;
}
</style>
